angular.module('app.controllers').controller('PhasesCtrl', function (DataTablesFactory, phasesListFilter, phasesList) {
    const vm = this;

    vm.phases = phasesList.list;
    vm.stats = phasesList.stats;
    vm.filter = phasesListFilter;

    vm.moreStats = 0;
    vm.getMoreStats = () => {
        vm.moreStats = 1;
        // todo: fetching stats
    };

    vm.dt = DataTablesFactory.init({
        scope: vm,
    });
});
